import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { PushNotificationService } from 'src/app/modules/retailer/services/push-notification.service';

@Component({
  selector: 'app-push-notification-campaign-list',
  templateUrl: './push-notification-campaign-list.component.html',
  styleUrls: ['./push-notification-campaign-list.component.scss']
})
export class PushNotificationCampaignListComponent implements OnInit {

  public loginData: any;

  public pushNotificationCampaigns: any = [];
  public pushNotificationCampaignsPage: number = 1;
  public pushNotificationCampaignsCount: number = 0;
  public pushNotificationCampaignsLoading: boolean = false;

  public pushNotificationCampaignDetailsPopData: any;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _pushNotificationService: PushNotificationService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  // Go to create push notificaiton campaign page
  createPushNotificationCampaign(){
    this._router.navigate(['/retailer/manage-push-notification-campaign'], {});
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.pushNotificationCampaignsPage = 1;
    this.getPushNotificationCampaigns();
  }

  // Get push notification campaigns
  getPushNotificationCampaigns() {
    this.pushNotificationCampaigns = [];
    this.pushNotificationCampaignsCount = 0;
    this.pushNotificationCampaignsLoading = true;

    this._pushNotificationService.getPushNotificationCampaigns(this.loginData.token, this.loginData.user_details.provider_id, this.pushNotificationCampaignsPage).subscribe(async getPushNotificationCampaignsResponse => {
      this.pushNotificationCampaignsLoading = false;

      if (getPushNotificationCampaignsResponse.status === true) { // Success
        this.pushNotificationCampaigns = getPushNotificationCampaignsResponse.push_notification_campaigns;
        this.pushNotificationCampaignsCount = getPushNotificationCampaignsResponse.total_count;
      } else {
        this._utilService.showToast(getPushNotificationCampaignsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getPushNotificationCampaigns
      this.pushNotificationCampaignsLoading = false;
    });
  }

  // Push notification campaign page change
  onPushNotificationCampaignsPageChange(event: any) {
    this.pushNotificationCampaignsPage = event;
    this.getPushNotificationCampaigns();
  }

  // Toggle 
  togglePushNotificationCampaignDetailsPopover(popover, pushNotificationCampaign: any) {
		if (popover.isOpen()) {
      this.pushNotificationCampaignDetailsPopData = null;
			popover.close();
		} else {
      this.pushNotificationCampaignDetailsPopData = pushNotificationCampaign;
			popover.open();
		}
	}

  // On edit push notification campaign
  onEditPushNotificationCampaign(pushNotificationCampaign: any) {
    this._router.navigate(['/retailer/manage-push-notification-campaign'], {
      state: { 
        pushNotificationCampaign: pushNotificationCampaign 
      }
    });
  }

}
